import { getRequest, postRequest } from './api'

const module = 'comment'
export function getCommentList(params = {}) {
  const url = `${module}/index`
  return getRequest(url, { ...params, per_page: 100000000 })
}

export function addComment(params = {}) {
  const url = `${module}/add`
  return postRequest(url, params)
}

export function editComment(params = {}) {
  const url = `${module}/edit`
  return postRequest(url, params)
}

export function getCommentDetail(params = {}) {
  const url = `${module}/detail`
  return getRequest(url, params)
}

export function deleteComment(params = {}) {
  const url = `${module}/delete`
  return postRequest(url, params)
}
